module.exports = __webpack_public_path__ + "static/media/member-emblem-purple.8131a5f9.png";